import React                       from 'react';
import { observer }                from 'mobx-react';
import Row                         from 'components/App/Row';
import { Col }                     from 'antd';
import CardBox                     from 'components/App/CardBox';
import FormattedMessageWrapper     from 'components/App/FormattedMessageWrapper';
import GridInfo                    from 'components/App/GridInfo';
import { getTranslatedlMeanLabel } from 'constants/DemandLogisticMeans';
import DemandModel                 from 'models/DemandModel';
import DemandLogisticModel         from 'models/DemandLogisticModel';
import { ApiCollection }           from 'collections/ApiCollection';
import DemandTypeModel             from 'models/DemandTypeModel';

interface ContentProps {
  demand: DemandModel;
  demandLogistic: DemandLogisticModel;
  demandTypeCollection: ApiCollection;
}

const Content = observer(({
  demand,
  demandLogistic,
  demandTypeCollection,
}: ContentProps) => {
  const demandType = demandTypeCollection.find(dt => dt.id === demand.demandTypeId) as DemandTypeModel;

  const firstData = [
    [
      {
        label: <FormattedMessageWrapper id="Nature" />,
        value:
          demandType &&
          (demandType.reference === 'logistic_vehicle' ? (
            <FormattedMessageWrapper id="Véhicule" />
          ) : (
            <FormattedMessageWrapper id="Matériel" />
          )),
      },
    ],
    [
      {
        label: <FormattedMessageWrapper id="Hauteur" />,
        value: demandLogistic.height,
      },
    ],
    [
      {
        label: <FormattedMessageWrapper id="Longueur" />,
        value: demandLogistic.length,
      },
    ],
    [
      {
        label: <FormattedMessageWrapper id="Largeur" />,
        value: demandLogistic.width,
      },
    ],
    [
      {
        label: <FormattedMessageWrapper id="Poids" />,
        value: demandLogistic.weight,
      },
    ],
  ];

  const secondData = [
    [
      {
        label: <FormattedMessageWrapper id="Moyen utilisé pour la livraison" />,
        value: demandLogistic.means.map((mean: string, index: number) => (
          <React.Fragment key={mean}>
            {getTranslatedlMeanLabel(mean)}
            {index !== demandLogistic.means.length - 1 && <span>, </span>}
          </React.Fragment>
        )),
      },
    ],
  ];

  return (
    <>
      <GridInfo data={firstData} />
      <br />
      <Row>
        <Col lg={12} md={24}>
          <GridInfo data={secondData} />
        </Col>
      </Row>
    </>
  );
});

interface DemandLogisticBoxProps {
  demand: DemandModel;
  demandLogistic: DemandLogisticModel;
  demandTypeCollection: ApiCollection;
}

const DemandLogisticBox = ({
  demand,
  demandLogistic,
  demandTypeCollection,
}: DemandLogisticBoxProps) => (
  <CardBox
    content={
      <Content
        demand={demand}
        demandLogistic={demandLogistic}
        demandTypeCollection={demandTypeCollection}
      />
    }
    title={<FormattedMessageWrapper id="Spécifications de l'élément" />}
  />
);

export default DemandLogisticBox;
